import { atom, createStore } from 'jotai'
import { getPlatformGlobal, setPlatformGlobals } from '../../index'
import { DefaultApiViewStateAtom } from './types'
import type {
  ApiViewStatesAtom,
  GlobalViewStatesAtom,
  ViewTypesByNameAtom,
} from './types'

export const viewStateStore =
  getPlatformGlobal('globalViewStateStore') ?? createStore()

/**
 * Global set of view states.
 * Key is scopeToString(scope)
 */
export const globalAtom =
  getPlatformGlobal('globalViewStatesAtom') ?? atom<GlobalViewStatesAtom>({})
globalAtom.debugLabel = 'viewstate.global.active'

/**
 * Global set of all view states for given scopes.
 * Key is scopeToInternalString(scope)
 */
export const viewStatesFromApi =
  getPlatformGlobal('apiViewStatesAtom') ?? atom<ApiViewStatesAtom>({})

export const defaultViewStateFromApi =
  getPlatformGlobal('defaultViewStateFromApiAtom') ??
  atom<DefaultApiViewStateAtom>({})

export const viewTypesByNameAtom =
  getPlatformGlobal('viewTypesByNameAtom') ?? atom<ViewTypesByNameAtom>({})

// TODO : This is not stateful. It avoided race conditions around refreshViewStates. Find alternative.
export const refreshedScopes: string[] =
  getPlatformGlobal('viewStateRefreshedScopes') ?? []

// TODO : This is not stateful. It avoided race conditions around refreshViewTypes. Find alternative.
export const refreshedTypes: string[] =
  getPlatformGlobal('viewStateRefreshedTypes') ?? []

setPlatformGlobals({
  viewTypesByNameAtom,
  globalViewStateStore: viewStateStore,
  globalViewStatesAtom: globalAtom,
  defaultViewStateFromApiAtom: defaultViewStateFromApi,
  apiViewStatesAtom: viewStatesFromApi,
  viewStateRefreshedScopes: refreshedScopes,
  viewStateRefreshedTypes: refreshedTypes,
})
